import React, {createContext, useContext} from "react";

export const ToastContext = createContext({
    showErrorToast: (text) => {},
    showSuccessToast: (text) => {},
    showToast: (text) => {},
});

// useToast - доступ к контексту тостов
export const useToast = () => useContext(ToastContext);
